import { Err, Ok } from "../deps.js";
import { select, updateStore } from "./fx.js";
export const PERSIST_LOADER_ID = "@@starfx/persist";
export function createTransform() {
    const transformers = {
        in: function (currentState) {
            return currentState;
        },
        out: function (currentState) {
            return currentState;
        },
    };
    const inTransformer = function (state) {
        return transformers.in(state);
    };
    const outTransformer = function (state) {
        return transformers.out(state);
    };
    return {
        in: inTransformer,
        out: outTransformer,
    };
}
export function createLocalStorageAdapter() {
    return {
        getItem: function* (key) {
            const storage = localStorage.getItem(key) || "{}";
            return Ok(JSON.parse(storage));
        },
        setItem: function* (key, s) {
            const state = JSON.stringify(s);
            try {
                localStorage.setItem(key, state);
            }
            catch (err) {
                return Err(err);
            }
            return Ok(undefined);
        },
        removeItem: function* (key) {
            localStorage.removeItem(key);
            return Ok(undefined);
        },
    };
}
export function shallowReconciler(original, persisted) {
    return { ...original, ...persisted };
}
export function createPersistor({ adapter, key = "starfx", reconciler = shallowReconciler, allowlist = [], transform, }) {
    function* rehydrate() {
        const persistedState = yield* adapter.getItem(key);
        if (!persistedState.ok) {
            return Err(persistedState.error);
        }
        let stateFromStorage = persistedState.value;
        if (transform) {
            try {
                stateFromStorage = transform.out(persistedState.value);
            }
            catch (err) {
                console.error("Persistor outbound transformer error:", err);
            }
        }
        const state = yield* select((s) => s);
        const nextState = reconciler(state, stateFromStorage);
        yield* updateStore(function (state) {
            Object.keys(nextState).forEach((key) => {
                state[key] = nextState[key];
            });
        });
        return Ok(undefined);
    }
    return {
        key,
        adapter,
        allowlist,
        reconciler,
        rehydrate,
        transform,
    };
}
export function persistStoreMdw({ allowlist, adapter, key, transform }) {
    return function* (_, next) {
        yield* next();
        const state = yield* select((s) => s);
        let transformedState = state;
        if (transform) {
            try {
                transformedState = transform.in(state);
            }
            catch (err) {
                console.error("Persistor inbound transformer error:", err);
            }
        }
        // empty allowlist list means save entire state
        if (allowlist.length === 0) {
            yield* adapter.setItem(key, transformedState);
            return;
        }
        const allowedState = allowlist.reduce((acc, key) => {
            if (key in transformedState) {
                acc[key] = transformedState[key];
            }
            return acc;
        }, {});
        yield* adapter.setItem(key, allowedState);
    };
}
//# sourceMappingURL=persist.js.map